module.exports = __webpack_public_path__ + "static/media/NotoSans-Medium.9b4aa0ee.woff";